import { render, staticRenderFns } from "./review-driver-document.vue?vue&type=template&id=e4fcf02a&scoped=true&"
import script from "./review-driver-document.vue?vue&type=script&lang=js&"
export * from "./review-driver-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fcf02a",
  null
  
)

export default component.exports